import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { config } from '@app/core/app-config';
import { AuthenticationService } from '@app/core/authentication/authentication.service';

@Component({
  standalone: false,
  selector: 'sbnb-magic-link-login',
  templateUrl: './magic-link-login.component.html',
  styleUrls: ['./magic-link-login.component.scss'],
})
export class MagicLinkLoginComponent implements OnInit {
  token: string;
  loading: boolean = false;

  title: string;
  error: string | null = null;

  generatedAnotherToken: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private authService: AuthenticationService
  ) { }

  ngOnInit() {
    this.route.params.subscribe((params) => {
      // Clean up any existing logged in users
      this.authService.logout(false);

      this.token = params['token'];

      if (!this.token) {
        this.error = 'No magic link token was provided. Something looks wrong.';
      }
    });
  }

  consumeToken(trust: boolean) {
    this.loading = true;

    this.authService.processMagicLink(this.token, trust).subscribe(
      (res: { data: any }) => {
        const user = res.data;

        localStorage.setItem('accessToken', user.token);

        setTimeout(() => {
          this.authService.getUserDetailsFromApi().subscribe((res) => {
            localStorage.setItem('user', JSON.stringify(res));

            this.authService.loginActions(config.DEFAULT_PAGE);
            this.loading = false;
          });
        }, 100);
      },
      (err) => {
        console.log(err);

        this.loading = false;

        if (err.status === 404) {
          this.title = 'Login link not valid';
          this.error =
            'This login link is not valid. Login links are valid for a single use only. Please request a new one.';
        } else if (err.status === 400 && err.error?.reason === 'expired') {
          this.generatedAnotherToken = true;
          this.title = 'This link has expired.';
          this.error = `We've generated and sent you a new one. Please check your email for a new link.`;
        } else {
          this.error =
            'This login link is not valid. Login links are valid for a single use only. Please request a new one.';
        }
      }
    );
  }
}
